import {
  IGroupGuideShopByState,
  IGuideShopCore,
  IGuideShopDetail,
  INearGuideShop,
} from 'types/guides/guideshop';
import constants from '../helpers/constants/guideshop';

export const formatGuideData: (data: any) => IGuideShopDetail = data => {
  const { address, hours } = data;
  const today = new Date();
  const currentHourDay = hours?.find(
    hour => hour.week_day.slug === constants.DAYS_OF_WEEK[today.getDay()]
  );
  const filterAttendants =
    data.attendants?.filter(attendant => attendant.role.slug === 'atendente_vendas') || [];

  return {
    id: data.id,
    name: data.name,
    slug: data.slug,
    phone: data.phone,
    status: data.status.slug,
    cnpj: data.accounting.cnpj,
    inaugurationDate: data.inauguration_forecast,
    urlGoogleBusiness: data.url_google_business,
    address: {
      street: address.address,
      complement: address.complement,
      neighborhood: address.neighborhood,
      number: address.number,
      cep: address.cep,
      city: address.city.name,
      uf: address.city.state.uf,
    },
    attendants: filterAttendants.map(attendant => ({
      id: attendant.id,
      name: attendant.name,
      email: attendant.email,
      whatsapp: attendant.whatsapp,
      able: attendant.able,
      profileImageUrl: attendant.profile_image_url,
      role: attendant.role.slug,
      workShift: {
        startService: attendant.work_shift?.start_service || '00:00:00',
        endService: attendant.work_shift?.end_service || '00:00:00',
      },
    })),
    hours: hours?.map(hour => ({
      weekDay: {
        slug: hour.week_day.slug,
        name: hour.week_day.name,
      },
      oppeningAt: formatHour(hour.oppening_at),
      closingAt: formatHour(hour.closing_at),
      service: hour.service,
    })),
    currentHour: {
      weekDay: {
        slug: currentHourDay?.week_day.slug || '',
        name: currentHourDay?.week_day.name || '',
      },
      oppeningAt: currentHourDay ? formatHour(currentHourDay.oppening_at) : '00h00',
      closingAt: currentHourDay ? formatHour(currentHourDay.closing_at) : '00h00',
      service: !!currentHourDay?.service,
    },
  } as IGuideShopDetail;
};

export const isCurrentTimeBetween = (startTime: string, endTime: string): boolean => {
  try {
    const currentTime = new Date();
    const startDate = new Date(currentTime);
    const endDate = new Date(currentTime);
    const [startHour, startMin, startSec] = startTime.split(':').map(Number);
    const [endHour, endMin, endSec] = endTime.split(':').map(Number);

    startDate.setHours(startHour, startMin, startSec, 0);
    endDate.setHours(endHour, endMin, endSec, 0);

    return currentTime >= startDate && currentTime <= endDate;
  } catch (err: any) {
    return false;
  }
};

export const formatNearGuideData: (data: any) => INearGuideShop = (data: any) => {
  const { address, coordinates, hours } = data;
  const today = new Date();
  const currentHourDay = hours?.find(
    hour => hour.week_day.slug === constants.DAYS_OF_WEEK[today.getDay()]
  );

  return {
    id: data.id,
    name: data.name,
    slug: data.slug,
    distance: data.distance,
    address: {
      street: address.address,
      complement: address.complement,
      neighborhood: address.neighborhood,
      number: address.number,
      cep: address.cep,
      city: address.city.name,
      uf: address.city.state.uf,
    },
    coordinates: {
      latitude: parseFloat(coordinates.latitude),
      longitude: parseFloat(coordinates.longitude),
    },
    currentHour: {
      weekDay: {
        slug: currentHourDay?.week_day.slug || '',
        name: currentHourDay?.week_day.name || '',
      },
      oppeningAt: currentHourDay ? formatHour(currentHourDay.oppening_at) : '00h00',
      closingAt: currentHourDay ? formatHour(currentHourDay.closing_at) : '00h00',
      service: !!currentHourDay?.service,
    },
  } as INearGuideShop;
};

export const groupStoresByState: (guideList: IGuideShopCore[]) => IGroupGuideShopByState[] = (
  guideList: IGuideShopCore[]
) => {
  const groupStores = [] as IGroupGuideShopByState[];

  guideList?.forEach(guide => {
    if (guide.status === 'Inativa') return;

    const indexSomeUf = groupStores.findIndex(store => store.state === guide.state);
    if (indexSomeUf >= 0) {
      groupStores[indexSomeUf].stores = [...groupStores[indexSomeUf].stores, guide];
      return;
    }

    groupStores.push({
      state: guide.state,
      stores: [guide],
    });
  });

  return groupStores;
};

export const capitalize = (sentence: string): string =>
  sentence.toLowerCase().replace(/\b\w/g, letter => letter.toUpperCase());

export const formatHour = (value: string) => {
  const [hour, minute] = value.split(':').slice(0, 2);
  return `${hour}h${minute}`;
};
